import { Box, Button, Paper, Typography } from "@mui/material";
import { Info, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { isOnsiteActivated } from "./utils";

const OnsiteProtectedRoute = ({ module, children }) => {
  if (isOnsiteActivated(module)) {
    return children;
  }

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: 520,
          width: "100%",
          p: 5,
          borderRadius: 3,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            mx: "auto",
            mb: 2,
            borderRadius: "50%",
            bgcolor: "info.light",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Info size={36} color="#1976d2" />
        </Box>

        <Typography variant="h5" fontWeight={700} gutterBottom>
          Module Not Activated
        </Typography>

        <Typography color="text.secondary" sx={{ mb: 4 }}>
          This onsite module is not activated for your system.
          <br />
          Please contact your system administrator to enable this module before
          attempting to access it.
        </Typography>
      </Paper>
    </Box>
  );
};

export default OnsiteProtectedRoute;
